import { render } from "./StackRequest.vue?vue&type=template&id=3f6be2f2"
import script from "./StackRequest.vue?vue&type=script&lang=js"
export * from "./StackRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__